export const calculateEcwTbw = (ecw?: number, tbw?: number) => {
  if (!ecw || !tbw) {
    return null;
  }

  return +(ecw / tbw).toFixed(3);
};
